import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-10 mt-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Família/Grupo de Exibição:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Pode ser o nome do carro ou tipo da familia ex: Gol ou Carros Hatch. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Layout de Exibição:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Valor Hora Mão de Obra:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Parâmetro utilizado nos calculos do valor da mão de obra dos itens por hora ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Exibir Pacote Fabrica:"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, "Mostra os itens de fabrica como pacote")
], -1)
const _hoisted_8 = { class: "d-flex w-100 justify-content-end" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save text-white" }, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "indicator-label"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle me-2" }, null, -1)

import { FamilyDetailView } from "@/models/CardapioModel";
import { reactive, watch, ref, nextTick } from "vue";
import { updateFamily } from "@/services/CardapioService";
import useAlert from "@/composables/Alert";
import useEmitter from "@/composables/Emmiter";
import Swal from "sweetalert2/dist/sweetalert2.js";
import InputLayout from "@/views/cardapio/components/InputLayout.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormFamily',
  props: {
    updateFamily: {}
  },
  setup(__props: any) {

const props = __props;

const ruleFormRef = ref();
const emitter = useEmitter();
const codConcessionaria = localStorage.getItem("filtroConcessionaria");
const { showTimeAlert } = useAlert();
const loading = reactive({
  submit: false,
  optionOptionExhibitionLayout: false,
});
const form = reactive({
  nameFamily: "",
  exhibitionLayout: "",
  exibirFabrica: 0,
  horaMaoObra: "",
  currentfamilyName: "",
});
const money = {
  decimal: ",",
  thousands: ".",
  prefix: "R$ ",
  precision: 2,
};

const rules = reactive({
  nameFamily: [
    {
      required: true,
      message: "Por favor, preencha. O preenchimento é obrigatório.",
      trigger: "blur",
    },
  ],
  exhibitionLayout: [
    {
      required: true,
      message: "Por favor, escolha um opção.",
      trigger: "blur",
    },
  ],
});

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      Swal.fire({
        title: "Deseja fazer alterações na familia?",
        showCancelButton: true,
        confirmButtonText: "Salvar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        text: "As alterações serão refletidas no app assim que forem salvas.",
      }).then((result) => {
        if (result.isConfirmed) {
          handleSubmit();
        } else if (result.isDenied) {
        }
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

watch(
  () => props.updateFamily,
  (newValue) => {
    if (newValue) {
      form.nameFamily = newValue.family;
      form.exibirFabrica = newValue.detail.exibirFabrica;
      form.exhibitionLayout = newValue.exhibitionLayout;
      form.currentfamilyName = newValue.family;

      nextTick(() => {
        form.horaMaoObra = newValue.detail.horaMaoObra;
      });
    }
  },
  { deep: true, immediate: true }
);

const handleSubmit = async () => {
  if (codConcessionaria && typeof codConcessionaria === "string") {
    loading.submit = true;

    const payload = {
      ...form,
      horaMaoObra: form.horaMaoObra.replace("R$", "").trim(),
      codConcessionaria: codConcessionaria,
    };

    await updateFamily(payload)
      .then((r) => {
        showTimeAlert(r.message);
        emitter.emit("update-family", {});
      })
      .catch(() => {
        showTimeAlert("Não foi possível completar a solicitação", "error");
      })
      .finally(() => (loading.submit = false));
  }
};


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_money = _resolveDirective("money")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: form,
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        "label-width": "auto",
        rules: rules
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_el_form_item, { prop: "nameFamily" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.nameFamily,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.nameFamily) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_4,
          _createVNode(_component_el_form_item, { prop: "exhibitionLayout" }, {
            default: _withCtx(() => [
              _createVNode(InputLayout, {
                modelValue: form.exhibitionLayout,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.exhibitionLayout) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_el_form_item, { prop: "horaMaoObra" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_input, {
                modelValue: form.horaMaoObra,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.horaMaoObra) = $event))
              }, null, 8, ["modelValue"]), [
                [_directive_money, money]
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _hoisted_7,
            _createVNode(_component_el_switch, {
              style: {"text-align":"right","margin-left":"15px"},
              modelValue: form.exibirFabrica,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.exibirFabrica) = $event)),
              "inactive-color": "#ff4949",
              "active-color": "#13ce66",
              "active-value": 1,
              "inactive-value": 0,
              "active-text": "Sim",
              "inactive-text": "Não"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm background_btn_1 text-white",
              id: "kt_button_1",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm(ruleFormRef.value))),
              disabled: loading.submit
            }, [
              (!loading.submit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(" Salvar ")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                    _hoisted_13,
                    _createTextVNode(" Aguarde... ")
                  ]))
            ], 8, _hoisted_9)
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}
}

})